'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _Avatar = require('./Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sizes = {
  LARGE: 'large',
  DEFAULT: 'default'
};

function getClassName(index, numAvatars) {
  switch (true) {
    case index === 0 && numAvatars === 3:
      return 'first-of-three';
    case index === 1 && numAvatars === 3:
      return 'second-of-three';
    case index === 2 && numAvatars === 3:
      return 'third-of-three';
    case index === 0 && numAvatars === 2:
      return 'first-of-two';
    case index === 1 && numAvatars === 2:
      return 'second-of-two';
    default:
      return '';
  }
}

function makeStyle(size) {
  var dimension = size === Sizes.LARGE ? 48 : 24;

  return {
    height: dimension,
    width: dimension
  };
}

var AutomatedMessageAvatars = function AutomatedMessageAvatars(_ref) {
  var responders = _ref.responders,
      isLastInGroup = _ref.isLastInGroup,
      size = _ref.size;

  var numAvatars = responders.size;

  if (!numAvatars) {
    return _react2.default.createElement(_Avatar2.default, { isLastInGroup: isLastInGroup });
  }

  if (numAvatars === 1) {
    return _react2.default.createElement(_Avatar2.default, { responder: responders.first(), isLastInGroup: isLastInGroup });
  }

  var avatars = responders.map(function (responder, index) {
    var className = getClassName(index, numAvatars);
    return _react2.default.createElement(_Avatar2.default, {
      className: className,
      key: (0, _responderGetters.getUserId)(responder),
      responder: responder,
      isLastInGroup: isLastInGroup
    });
  });

  var sizeClassName = size === Sizes.LARGE ? 'large' : '';
  var className = 'automated-message-avatars ' + sizeClassName;
  var style = makeStyle(size);

  return _react2.default.createElement(
    'span',
    { className: className, style: style },
    avatars
  );
};

AutomatedMessageAvatars.displayName = 'AutomatedMessageAvatars';

AutomatedMessageAvatars.propTypes = {
  isLastInGroup: _react.PropTypes.bool.isRequired,
  responders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  size: _react.PropTypes.oneOf((0, _underscore.values)(Sizes)).isRequired
};

AutomatedMessageAvatars.defaultProps = {
  responders: (0, _immutable.List)(),
  isLastInGroup: true,
  size: Sizes.DEFAULT
};

exports.default = AutomatedMessageAvatars;
module.exports = exports['default'];